/**
 * CRM API Client
 *
 * REST client instance for CRM API integration.
 */

import { RestClient } from '@/services/api/shared/restClient';
import { CRM_CONFIG } from './config';

export const crmClient = new RestClient({
  baseURL: CRM_CONFIG.ENDPOINT,
  timeout: CRM_CONFIG.TIMEOUT,
  retryConfig: {
    retries: CRM_CONFIG.RETRY.maxAttempts,
    retryDelay: () => CRM_CONFIG.RETRY.initialDelay,
  },
});
